import layout from '@/assets/brand/letras/letras.json';
import integralCheia from '@/assets/brand/letras/integral-cheia.png';
import integralContorno from '@/assets/brand/letras/integral-contorno.png';
import hCheia from '@/assets/brand/letras/h-cheia.png';
import hContorno from '@/assets/brand/letras/h-contorno.png';
import iCheia from '@/assets/brand/letras/i-cheia.png';
import iContorno from '@/assets/brand/letras/i-contorno.png';
import bCheia from '@/assets/brand/letras/b-cheia.png';
import bContorno from '@/assets/brand/letras/b-contorno.png';
import deltaCheia from '@/assets/brand/letras/delta-cheia.png';
import deltaContorno from '@/assets/brand/letras/delta-contorno.png';

/**
 * As letras do ∫hibΔ recortadas do raster-fonte do Wordmark
 * (scripts/recortar_letras_marca.py): o `letras.json` traz o quadro (largura ×
 * altura do raster) e o x/largura de cada letra, na ordem da palavra, para quem
 * monta a marca letra a letra manter o kerning original.
 */
export const LETTER_LAYOUT = layout;

export type LetterId = 'integral' | 'h' | 'i' | 'b' | 'delta';

export const LETTER_MASKS: Record<LetterId, { cheia: string; contorno: string }> = {
  integral: { cheia: integralCheia, contorno: integralContorno },
  h: { cheia: hCheia, contorno: hContorno },
  i: { cheia: iCheia, contorno: iContorno },
  b: { cheia: bCheia, contorno: bContorno },
  delta: { cheia: deltaCheia, contorno: deltaContorno },
};
